export default function groupArray<Item>(array: Item[], count: number): Item[][] {
	return array.reduce((groups: Item[][], item: Item, i) => {
		// eslint-disable-next-line no-bitwise
		const index = (i / count) | 0;
		if (groups.length > index) {
			groups[index].push(item);
		} else {
			groups[index] = [item];
		}
		return groups;
	}, []);
}
